import { Box, Flex, Heading, List, ListItem } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Glyph } from '~/components/glyph';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Markdown } from '~/components/markdown';

export type ScholarshipFeaturesSectionProps = {
  title: string;
  features: Array<{
    _id: string;
    glyphName: string;
    title: string;
    description: string;
  }>;
};

export function ScholarshipFeaturesSection({ title, features = [] }: ScholarshipFeaturesSectionProps) {
  return (
    <Box
      as='section'
      bgGradient={{
        base: 'white',
        md: 'linear(to-b, white, accent.sky.100)',
      }}
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer>
        <Flex
          flexDir={{
            base: 'column',
            md: 'row',
          }}
          gap={{
            base: '16px',
            md: '32px',
          }}
        >
          <HeadingWithEmphasis
            text={title}
            emphasisProps={{
              fontWeight: '500',
            }}
            headingProps={{
              as: 'h2',
              size: 'marketing-5xl',
              flex: {
                md: '0 0 352px',
              },
            }}
          />
          <List as='ul' display='flex' flex='1' flexWrap='wrap' gap='32px'>
            {features.map((feature) => (
              <ListItem
                key={feature._id}
                display='flex'
                flexDir='column'
                flex={{
                  xl: '0 1 352px',
                }}
                paddingRight={{
                  xl: '24px',
                }}
              >
                <Flex alignItems='center' gap='16px' marginBottom='8px'>
                  <Glyph height={48} name={feature.glyphName} width={48} />
                  <Heading as='p' flex='1' size='marketing-lg'>
                    {feature.title}
                  </Heading>
                </Flex>
                <Markdown markdownText={feature.description} />
              </ListItem>
            ))}
          </List>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
